import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface OrganizationStoreState {
  selectedOrganizationUuid: string | null;
  isSwitching: boolean;
  setSwitching: (isSwitching: boolean) => void;

  setSelectedOrganizationUuid: (uuid: string | null) => void;
  reset: () => void;
}

export const useOrganizationStore = create<OrganizationStoreState>()(
  devtools(
    (set) => ({
      selectedOrganizationUuid: null,
      isSwitching: false,
      setSwitching: (isSwitching) => set({ isSwitching }),

      setSelectedOrganizationUuid: (uuid) => set({ selectedOrganizationUuid: uuid }),

      reset: () => set({ selectedOrganizationUuid: null, isSwitching: false }),
    }),
    { name: "OrganizationStore" },
  ),
);
